<style scoped src="../assets/fs/newForm.css"/>
<template>
  <div class="hasbgpic hasHeader" style="margin-top: 40px">
    <div id="divBackgroundWrap">
      <div id="bgimgwrap" class="backgroundimgWrap">
        <img class="backgroundimg" src="../assets/fs/1721726525wCEXQ4.png" alt="">
        <div class="backgroundshade"></div>
      </div>
    </div>
    <div class="wjx-form">
      <div id="answerProcess" style="">
        <div class="processInner mainBgColor"></div>
      </div>
      <div id="toplogo">
        <img class="mblogo" src="//image.wjx.cn/images/newForm/bannerApplication@2x.png" alt="">
      </div>
      <div class="vote-header">
        <div id="toptitle">
          <span class="title-icon1"></span>
          <span class="htitle" id="htitle">
            <div>第二十二届中国食品安全大会报名</div>
          </span>
          <span class="title-icon2">
          </span>
        </div>
      </div>


    <form @submit.prevent="handleSubmit">
      <div class="form-group">
        <label for="orgName"><span class="req">*</span><span class="topicnumber">1.</span>企业名称</label>
      <input
          type="text"
          v-model="form.orgName"
          @input="filterOptions"
          @blur="validateOrgName"
          @keydown.down="incrementSelectedOption"
          @keydown.up="decrementSelectedOption"
          @keydown.enter="selectOption"
          list="optionsList"
          required
          placeholder="请输入企业名称"
      />
      <datalist id="optionsList">
        <option v-for="(option, index) in filteredOptions" :key="index" :value="option">
        </option>
      </datalist>
        <p v-if="errormsg.orgName" class="error">{{ errormsg.orgName }}</p>
      </div>

      <div class="form-group">
        <label for="position"><span class="req">*</span><span class="topicnumber">2.</span>职务</label>
        <input type="text" id="position" v-model="form.position" required placeholder="请输入职务" />
        <p v-if="errormsg.position" class="error">{{ errormsg.position }}</p>
      </div>
      <div class="form-group">
        <label for="name"><span class="req">*</span><span class="topicnumber">3.</span>姓名</label>
        <input type="text" id="name" v-model="form.name" required placeholder="请输入姓名" />
        <span v-if="errormsg.name" class="error">{{ errormsg.name }}</span>
      </div>
      <div class="form-group">
        <label for="idNumber"><span class="req">*</span><span class="topicnumber">4.</span>身份证号码</label>
        <input type="text" id="idNumber" v-model="form.idNumber" @blur="validateIdNumber" required   placeholder="请输入身份证号码"/>

        <p v-if="errormsg.idNumber" class="error">{{ errormsg.idNumber }}</p>
      </div>
      <div class="form-group">
        <label for="phoneNumber"><span class="req">*</span><span class="topicnumber">5.</span>手机号码</label>
        <input type="text" id="phoneNumber" v-model="form.phone" @blur="validatePhoneNumber" required  placeholder="请输入手机号码"/>

        <p v-if="errormsg.phone" class="error">{{ errormsg.phone }}</p>
      </div>
      <div class="form-group">
        <label for="isCheckIn"><span class="req">*</span><span class="topicnumber">6.</span>是否入住</label>

        <div class="radio-group">
          <div class="radios" >
          <span for="isCheckIn1"  style="width: 30px">是</span>
          <input type="radio" v-model="form.checkIn" value="1"  style="width: 30px"/>
          </div>
          <div class="radios">
            <span   for="isCheckIn2" style="width: 30px">否</span>
            <input type="radio" v-model="form.checkIn" value="0"   style="width: 30px"/>
          </div>
        </div>
        <p v-if="errormsg.checkIn" class="error">{{ errormsg.checkIn }}</p>

      </div>
      <div class="form-group" v-if="form.checkIn === '1'">
        <!--入住时间 -->
        <label for="checkTime"><span class="topicnumber">7.</span>入住时间</label>
        <select id="checkTime" v-model="form.checkTime" placeholder="请选择入住时间">
          <option value="2024年12月15日">2024年12月15日</option>
        </select>
      </div>
      <div class="form-group" v-if="form.checkIn === '1'">
         <!--离开时间 -->
        <label for="checkOutTime"><span class="topicnumber">8.</span>离开时间</label>
        <select id="checkOutTime" v-model="form.checkOutTime" placeholder="请选择离开时间">
          <option value="2024年12月16日">2024年12月16日</option>
          <option value="2024年12月17日">2024年12月17日</option>
          <option value="2024年12月18日">2024年12月18日</option>
        </select>
      </div>
      <div class="form-group">
        <button type="submit"  :disabled="isDisabled">提交</button>
        <p v-if="error" class="error">{{ error }}</p>
      </div>
    </form>



    </div>
  </div>
</template>

<script>
import api from "@/api/register";

export default {
  data() {
    return {
      form:{
        orgName: '',
        position: '',
        name: '',
        idNumber: '',
        phone: '',
        checkIn:'1',
        checkTime: '',
        checkOutTime: ''
      },
      errormsg:{
        orgName: '',
        position: '',
        name: '',
        idNumber: '',
        phone: '',
        checkIn:'',
      },

      isDisabled: false,
      companies: [],
      selectedCompany: null,

      error: '',
      options: [],
      filteredOptions: [],
      selectedIndex: 0,
    };
  },


  created() {
      this.companiesOrg();
  },

  methods: {

    companiesOrg() {
      api.companiesOrg({"title":this.orgName}).then(res => {
          if (res.code === 200){
            this.companies = res.data;
            res.data.forEach(item => {
              this.options.push(item.title);
            })
          }else {
            this.companies = [];
          }
      })
    },

    validateOrgName(){
      if (this.form.orgName){
        api.verificationOrg(this.form).then(res => {
          console.log("verificationOrg",res);
          if (res.code !== 200){
            this.errormsg.orgName=res.data;
            this.isDisabled =true;
          }else {
            this.errormsg.orgName="";
            if (this.isFile()){
              this.isDisabled =false;
            }

          }
        });
      }
    },

    validateIdNumber() {
      const idNumberRegex = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      if (!idNumberRegex.test(this.form.idNumber)) {

        this.errormsg.idNumber = '请输入有效的身份证号码';
        this.isDisabled =true;
      } else {
        api.verification(this.form).then(res => {
          if (res.code !== 200){
            this.errormsg.idNumber="该用户已经存在";
            this.isDisabled =true;
          }else {
            this.errormsg.idNumber="";
            if (this.isFile()){
              this.isDisabled =false;
            }
          }
        }).catch(e => {
          console.log(e);
          this.errormsg.idNumber="yyyyy  s";
        });


      }
    },


    validatePhoneNumber() {
      const phoneNumberRegex = /^1[3-9]\d{9}$/;
      if (!phoneNumberRegex.test(this.form.phone)) {
        this.errormsg.phone = '请输入有效的手机号码';
      } else {
        api.verification(this.form).then(res => {
          console.log("verification",res);
          if (res.code !== 200){
            this.errormsg.phone="该用户已经存在";
            this.isDisabled =true;
          }else {
            this.errormsg.phone="";
            if (this.isFile()){
              this.isDisabled =false;
            }
          }
        });

      }



    },


     isFile(){
       if (this.errormsg.phone || this.errormsg.idNumber || this.errormsg.position || this.errormsg.orgName||this.errormsg.name) {
          return false
       }else {
         return true
       }

     },
     handleSubmit() {


       this.isDisabled =false;
       this.validateOrgName();
       this.validatePhoneNumber();
       this.validateIdNumber();





       if (!this.form.isCheckIn) {
         this.errormsg.isCheckIn = '请选择是否入住';
         this.isDisabled =true;
       }


      if (!this.form.orgName) {
        this.errormsg.orgName = '企业名称为必填项';
        this.isDisabled =true;
      }

       if (!this.form.position) {
         this.errormsg.position = '职位为必填项';
         this.isDisabled =true;
       }
       if (!this.form.name) {
         this.errormsg.name = '姓名为必填项';
         this.isDisabled =true;
       }


      if (!this.form.idNumber) {
        this.errormsg.idNumber = '身份证号码必填';
        this.isDisabled =true;
      }


      if (!this.form.phone) {
        this.errormsg.phone = '手机号码必填';
        this.isDisabled =true;
      }


       if (this.errormsg.phone || this.errormsg.idNumber || this.errormsg.position || this.errormsg.orgName||this.errormsg.name) {
         this.error = '请检查输入的信息';
         this.isDisabled =true;
         return;
       }

       api.verification(this.form).then(res => {
        console.log("verification",res);
        if (res.code !== 200){
          this.error=res.message;
          this.isDisabled =true;
          return;
        }
      });


      api.save(this.form).then(res => {
        console.log(res);
        if (res.code === 200) {
          this.resetForm();
          this.errormsg = {};
          alert("增加成功")
        //  this.error = "增加成功";
        } else {
          alert("报名失败")
          //this.error = res.message;
        }
      })
    },



    resetForm() {
      this.selectedCompany = null;
      this.idNumberError = '';
      this.phoneNumberError = '';
      this.error = '';
      this.form = {};
      this.form.checkIn="1";

    },

    filterOptions() {
      this.filteredOptions = this.options.filter((option) =>
          option.toLowerCase().includes(this.form.orgName.toLowerCase())
      );
      this.selectedIndex = 0;
    },
    incrementSelectedOption() {
      if (this.filteredOptions.length === 0) return;
      this.selectedIndex = (this.selectedIndex + 1) % this.filteredOptions.length;
      this.form.orgName = this.filteredOptions[this.selectedIndex];
    },
    decrementSelectedOption() {
      if (this.filteredOptions.length === 0) return;
      this.selectedIndex =
          (this.selectedIndex - 1 + this.filteredOptions.length) %
          this.filteredOptions.length;
      this.form.orgName = this.filteredOptions[this.selectedIndex];
    },
    selectOption() {
      if (this.filteredOptions.length > 0) {
        this.form.orgName = this.filteredOptions[this.selectedIndex];
      }
    },
  }
};
</script>

<style scoped>
.registration-form {
  max-width: 400px;
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.form-group {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-bottom: 5px;
}

input, select {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
}

button {
  padding: 10px 15px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.error {
  color: red;
  margin-top: 10px;
}
</style>

<style scoped>
.wjx-form {
  max-width: 400px;
  margin: 0 auto;
  padding: 0px;
  background-color: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

h2 {
  text-align: center;
  margin-bottom: 20px;
  font-size: 24px;
  font-weight: bold;
  color: #19A76D !important;
}

.form-item {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  color: #333;
  font-size: 14px;
}

input, select {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  font-size: 16px;
  background-color: #fff;
  color: #333;
}

button {
  padding: 10px 15px;
  background-color: #1aad19;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  width: 100%;
  transition: background-color 0.3s;
}

button:hover {
  background-color: #159013;
}

button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.error {
  color: red;
  margin-top: 5px;
  font-size: 14px;
}





/* 使用css */
#divBackgroundWrap {
  position: fixed;
  /*position:absolute\0;*/
  top: 0px;
  width: 100%;
  bottom: 0;
  left: 0;
  z-index: -5;
  background-image: url("//pubnew.paperol.cn/20240723/1721726525wCEXQ4.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: left top;
  background-color: #19A76D;
}
#divBackgroundWrap {
  background-image: none;
}


.req{
  top: 0;
  left: -12px;
  color: #ff4040 !important;
  margin: 2px 2px 0 2px;
}

.htitle{
  ont-size: 24px;
  line-height: 32px;
  font-weight: 600;
  -webkit-font-smoothing: antialiased;
  margin: 0;
  padding: 0;
  text-align: center;
}

#toptitle{align-items:center;justify-content:center;padding:32px 40px}
#toptitle .htitle{
  margin:0 20px;font-weight:500!important;color:#19A76D !important;font-size:21px}


#toplogo{padding-bottom:0}
#toplogo  img{
  margin:0;
  background:#80CFAF;
  width:100%;
  max-width:100%;
}

.radio-group{
  margin-top: 10px;
  margin-left: 20px;
}
</style>
